import React, { Component } from 'react';

import {
  StyledBoxInside,
  StyledTitleWidget,
  StyledWrapperStationDirectory,
  StyledWrapperPaginator,
  StyledTwoLevelBreadcrumb
} from './style';
import { OndaceroWhite } from '../../../../../assets/images/index';
import PaginatorVertical from '../../../core/PaginatorVertical';
import StationTable from './StationTable';
import InfiniteScroller from '../../../core/InfiniteScroller';
import SearchFormControl from './SearchFormControl';

import {
  getRadioStationsRented,
  getRadioStationsRentedByParams,
  getRadioBroadcasters
} from '../../../../utils/apiRadioStationRented';

class RentalInquiry extends Component {
  constructor() {
    super();
    this.state = {
      stationRented: [],
      stations: [],
      page: 0,
      total: 0,
      size: 20,
      codeRadioBroadcaster: '',
      fromDate: '',
      toDate: ''
    };
  }

  componentDidMount() {
    const { page, size } = this.state;
    getRadioBroadcasters()
      .then(stat => {
        const newStations = [];
        stat.map((sta, index) =>
          newStations.push({
            value: sta.codeRadioBroadcaster,
            text: sta.name,
            id: index
          })
        );
        this.setState({
          stations: newStations
        });
      })
      .catch(e => {
        console.error(e);
      });
    getRadioStationsRented(page, size)
      .then(stationRented =>
        this.setState({
          stationRented: stationRented.content,
          page: stationRented.page,
          size: stationRented.size,
          total: stationRented.total
        })
      )
      .catch(e => {
        console.error(e);
      });
  }

  loadMore = () => {
    const {
      stationRented,
      codeRadioBroadcaster,
      fromDate,
      toDate,
      size,
      page
    } = this.state;
    getRadioStationsRentedByParams(
      codeRadioBroadcaster,
      fromDate,
      toDate,
      page + 1,
      size
    )
      .then(data => {
        this.setState({
          stationRented: stationRented.concat(data.content),
          total: data.total,
          page: data.page,
          size: data.size
        });
      })
      .catch(() => {});
  };

  parseDate = date => {
    if (date.split('-').length === 3) {
      const YY = date.split('-')[2];
      const MM = date.split('-')[1];
      const DD = date.split('-')[0];

      return `${YY}-${MM}-${DD}`;
    }
    return '';
  };

  hadleSearch = data => {
    this.setState({
      codeRadioBroadcaster: data.station === null ? '' : data.station,
      fromDate: data.dateFrom === null ? '' : this.parseDate(data.dateFrom),
      toDate: data.dateTo === null ? '' : this.parseDate(data.dateTo)
    });
    getRadioStationsRentedByParams(
      data.station === null ? '' : data.station,
      data.dateFrom === null ? '' : this.parseDate(data.dateFrom),
      data.dateTo === null ? '' : this.parseDate(data.dateTo),
      0,
      20
    )
      .then(data => {
        this.setState({
          stationRented: data.content,
          total: data.total,
          page: data.page,
          size: data.size
        });
      })
      .catch(() => {});
  };

  onReturnServices = () => {
    this.props.history.push('/servicios-onda-cero');
  };

  controlVisibleItem = () => {
    const { size, page, total } = this.state;
    if (page === 0) {
      if (total < size) {
        return total;
      }
      return size;
    }
    if (size * (page + 1) > total) {
      return total;
    }
    return size * (page + 1);
  };

  render() {
    const { stationRented, stations, total, page, size } = this.state;
    return (
      <div className="pressResume_container">
        <StyledBoxInside>
          <StyledTitleWidget
            title="Alquiler de emisoras"
            type="ondacero"
            icon={OndaceroWhite}
            small
          />
          <SearchFormControl options={stations} onSearch={this.hadleSearch} />
          <StyledTwoLevelBreadcrumb
            first="Servicios Onda Cero"
            second="Alquiler de emisoras"
            onBack={this.onReturnServices}
          />
          <StyledWrapperStationDirectory>
            <InfiniteScroller
              loadMore={() => this.loadMore()}
              hasMore={page * size > total}
            >
              {stationRented && <StationTable dataStation={stationRented} />}
            </InfiniteScroller>
          </StyledWrapperStationDirectory>
          <StyledWrapperPaginator>
            {stationRented && (
              <PaginatorVertical
                visibleItems={this.controlVisibleItem()}
                totalItems={total}
              />
            )}
          </StyledWrapperPaginator>
        </StyledBoxInside>
      </div>
    );
  }
}

export default RentalInquiry;
